import { render, staticRenderFns } from "./Item2ColMultirowEl.vue?vue&type=template&id=e9d532f2&"
import script from "./Item2ColMultirowEl.vue?vue&type=script&lang=ts&"
export * from "./Item2ColMultirowEl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports